import React from 'react';
import { Link } from 'react-router-dom';

import Header from '../../components/header';
import Footer from '../../components/footer';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

export default function A3() {
  return (
    <>
      <Header content="Informações Mínimas" />
      <div className="a3-container container">
        <div className="a3-content">
          <div className="row mb-5">
            <ul className="a3-list">
              <li>
                Ter em mãos o guia de senha
              </li>
              <li>Utilizar um computador com Windows 7 profissional  ou superior;</li>
              <li>
                Desativar o antivírus e o gerenciador de downloads (caso tenha);
              </li>
              <li>
                Utilizar um usuário no computador com permissões
                administrativas;
              </li>
            </ul>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-6">
            <div className="row justify-content-center">
              <button type="submit" className="button-a3 btn">
                <Link to="/support">SUPORTE TÉCNICO</Link>
              </button>
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-center">
              <button type="submit" className="button-a3 btn">
                <Link to="/tutoriala3">INICIAR TUTORIAL</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
